import React, { useEffect, useState } from 'react';
import { useBMP } from '../context/BMPContext';
import useMarketQuotas from '../hooks/useMarketQuotas';
import QuotaCard from '../cards/QuotaCard';
import { useTranslation } from 'react-i18next';
import './CatalogView.css';

export default function CatalogView() {
  const { t } = useTranslation();
  const { isProducer, viewParams } = useBMP();
  const { quotas, loading, fetchQuotas } = useMarketQuotas();
  const [filterZone, setFilterZone] = useState('');
  const [filterFruit, setFilterFruit] = useState('');

  useEffect(() => {
    const params = {};
    if (filterZone) params.zone = filterZone;
    if (filterFruit) params.fruit_type = filterFruit;
    if (isProducer) params.mine = '1';
    if (viewParams?.q) params.q = viewParams.q;
    fetchQuotas(params);
  }, [fetchQuotas, filterZone, filterFruit, isProducer, viewParams]);

  return (
    <div className="catalog">
      <div className="bmp-section-header">
        <h2>{isProducer ? t('bmp_my_quotas') : t('bmp_browse_quotas')}</h2>
      </div>

      <div className="catalog-filters">
        <select value={filterZone} onChange={e => setFilterZone(e.target.value)}>
          <option value="">{t('mkt_all_zones')}</option>
          <option value="norte">{t('mkt_zone_north')}</option>
          <option value="sur">{t('mkt_zone_south')}</option>
        </select>
        <select value={filterFruit} onChange={e => setFilterFruit(e.target.value)}>
          <option value="">{t('mkt_all_fruit')}</option>
          <option value="convencional">{t('mkt_conventional')}</option>
          <option value="organico">{t('mkt_organic')}</option>
        </select>
        <span className="catalog-count">{quotas.length} {t('bmp_results')}</span>
      </div>

      {loading ? (
        <div className="bmp-loading">{t('loading_dots')}</div>
      ) : quotas.length === 0 ? (
        <div className="bmp-empty">{t('bmp_no_quotas_available')}</div>
      ) : (
        <>
          {/* Featured quotas */}
          {quotas.some(q => q.is_featured) && (
            <div className="catalog-featured">
              <h3 className="catalog-featured-title">{t('bmp_featured')}</h3>
              <div className="catalog-grid">
                {quotas.filter(q => q.is_featured).map(q => <QuotaCard key={q.id} quota={q} />)}
              </div>
            </div>
          )}
          {/* All quotas */}
          <div className="catalog-grid">
            {quotas.filter(q => !q.is_featured).map(q => <QuotaCard key={q.id} quota={q} />)}
          </div>
        </>
      )}
    </div>
  );
}
